import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  altBg?: boolean;
  narrow?: boolean;
}
export function SectionWrapper({
  children,
  className = '',
  id,
  altBg = false,
  narrow = false
}: SectionWrapperProps) {
  return <section id={id} className={`py-20 md:py-28 px-4 sm:px-6 lg:px-8 ${altBg ? 'bg-cream-alt' : 'bg-cream'} ${className}`} data-id="element-113">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: [0.21, 0.47, 0.32, 0.98]
    }} className={`mx-auto ${narrow ? 'max-w-2xl' : 'max-w-3xl'}`} data-id="element-114">
        {children}
      </motion.div>
    </section>;
}